export const carouselItems = [
  {
    id: 'c1',
    title: '《我独自升级》第二季重磅回归',
    subtitle: '韩漫天花板 · 全网热度破亿',
    desc: '实力画风与热血剧情完美融合，程肖宇觉醒之路再掀高潮，每周五晚准时更新，锁定尾巴漫画追更不迷路。',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20manga%20illustration%20scene%20with%20a%20powerful%20warrior%20surrounded%20by%20dark%20magical%20energy%20and%20glowing%20blue%20flames%2C%20dramatic%20lighting%20from%20above%2C%20comic%20panel%20style%20composition%2C%20vibrant%20action%20pose%2C%20warm%20orange%20and%20deep%20navy%20color%20palette%2C%20clean%20gradient%20background%20with%20subtle%20particle%20effects%2C%20anime%20art%20style%2C%20high%20detail%20rendering%2C%20cinematic%20atmosphere&width=800&height=500&seq=manga-carousel-01&orientation=landscape',
    tag: '🔥 热更中',
    tagColor: 'primary',
  },
  {
    id: 'c2',
    title: '《剑尊归来》漫画独家连载上线',
    subtitle: '国漫巅峰武侠 · 收藏破百万',
    desc: '华山派最后的剑尊转世重生，一剑破万法，快意江湖恩怨，尾巴漫画全网首发高清画质，一口气看个痛快。',
    image: 'https://readdy.ai/api/search-image?query=A%20martial%20arts%20manga%20scene%20with%20a%20swordsman%20in%20flowing%20white%20robes%20standing%20on%20a%20mountain%20peak%2C%20cherry%20blossom%20petals%20floating%20in%20the%20air%2C%20traditional%20Chinese%20ink%20wash%20painting%20style%20blended%20with%20modern%20manga%20aesthetics%2C%20warm%20golden%20sunset%20light%2C%20misty%20mountain%20background%2C%20elegant%20composition%2C%20soft%20cream%20and%20coral%20tones&width=800&height=500&seq=manga-carousel-02&orientation=landscape',
    tag: '⭐ 独家',
    tagColor: 'accent',
  },
  {
    id: 'c3',
    title: '日漫经典《海贼王》全彩重制版',
    subtitle: '路飞冒险再开 · 情怀永不褪色',
    desc: '东海到新世界，草帽一伙的传奇旅程以全彩高清画质重新呈现，每一格都是壁纸级享受。',
    image: 'https://readdy.ai/api/search-image?query=A%20pirate%20adventure%20manga%20illustration%20with%20a%20cheerful%20young%20pirate%20character%20with%20a%20straw%20hat%20on%20a%20wooden%20ship%20deck%2C%20vast%20blue%20ocean%20and%20fluffy%20white%20clouds%20in%20the%20background%2C%20vivid%20anime%20art%20style%2C%20bright%20sunny%20day%20lighting%2C%20dynamic%20composition%20with%20wind%20effects%2C%20warm%20and%20vibrant%20color%20palette%2C%20adventurous%20atmosphere%2C%20clean%20illustration&width=800&height=500&seq=manga-carousel-03&orientation=landscape',
    tag: '🎨 全彩',
    tagColor: 'accent',
  },
  {
    id: 'c4',
    title: '《咒术回战》涩谷事变篇专题',
    subtitle: '暗黑热血巅峰 · 伏笔全解析',
    desc: '五条悟封印、虎杖觉醒、两面宿傩降临——完整回顾涩谷事变名场面，配合深度剧情分析解读。',
    image: 'https://readdy.ai/api/search-image?query=A%20dark%20supernatural%20manga%20scene%20with%20a%20character%20in%20modern%20streetwear%20surrounded%20by%20crimson%20and%20black%20energy%20waves%2C%20urban%20nighttime%20cityscape%20background%20with%20neon%20signs%2C%20dramatic%20contrast%20lighting%2C%20edgy%20composition%2C%20warm%20orange%20accents%20against%20deep%20charcoal%20tones%2C%20anime%20art%20style%2C%20intense%20atmosphere%2C%20high%20detail&width=800&height=500&seq=manga-carousel-04&orientation=landscape',
    tag: '📖 专题',
    tagColor: 'primary',
  },
  {
    id: 'c5',
    title: '尾巴漫画原创漫画大赛获奖作品展',
    subtitle: '新锐作者集结 · 原创力量崛起',
    desc: '首届尾巴原创漫画大赛圆满收官，15部获奖作品全部上线，题材涵盖奇幻、悬疑、恋爱，快来为你喜欢的作品打call。',
    image: 'https://readdy.ai/api/search-image?query=A%20creative%20manga%20art%20exhibition%20scene%20with%20multiple%20colorful%20comic%20panels%20floating%20in%20a%20gallery%20space%2C%20diverse%20character%20illustrations%20in%20various%20styles%20displayed%20on%20large%20screens%2C%20warm%20ambient%20lighting%2C%20modern%20minimalist%20gallery%20setting%2C%20creative%20atmosphere%2C%20soft%20cream%20and%20coral%20color%20scheme%2C%20artistic%20composition%2C%20celebration%20mood&width=800&height=500&seq=manga-carousel-05&orientation=landscape',
    tag: '🏆 赛事',
    tagColor: 'accent',
  },
];

export const topics = [
  { id: 't1', name: '韩漫推荐', count: '32.6万讨论', hot: true },
  { id: 't2', name: '日漫连载', count: '28.1万讨论', hot: true },
  { id: 't3', name: '国漫崛起', count: '21.8万讨论', hot: true },
  { id: 't4', name: '热血战斗', count: '19.5万讨论', hot: false },
  { id: 't5', name: '悬疑推理', count: '16.2万讨论', hot: false },
  { id: 't6', name: '恋爱甜漫', count: '15.7万讨论', hot: false },
  { id: 't7', name: '搞笑日常', count: '14.3万讨论', hot: false },
  { id: 't8', name: '奇幻冒险', count: '13.9万讨论', hot: false },
  { id: 't9', name: '武侠仙侠', count: '12.4万讨论', hot: false },
  { id: 't10', name: '恐怖惊悚', count: '10.8万讨论', hot: false },
  { id: 't11', name: '同人创作', count: '9.6万讨论', hot: false },
];

export const comments = [
  {
    id: 'cm1',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20anime%20style%20girl%20avatar%20with%20pink%20hair%20and%20big%20eyes%2C%20simple%20warm%20toned%20gradient%20background%2C%20soft%20illustration%20style%2C%20friendly%20expression%2C%20clean%20minimal%20design&width=120&height=120&seq=avatar-cm-01&orientation=squarish',
    name: '漫小兔',
    time: '2小时前',
    content: '尾巴漫画的阅读体验真的太棒了！下拉式阅读完全不用翻页，一口气看了《我独自升级》五十话，根本停不下来。而且画质超级清晰，比我在其他地方看的都要好很多～',
    likes: 1286,
    work: '在看《我独自升级》',
  },
  {
    id: 'cm2',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cool%20anime%20style%20boy%20avatar%20with%20dark%20hair%20and%20sharp%20eyes%2C%20simple%20warm%20toned%20gradient%20background%2C%20clean%20illustration%20style%2C%20confident%20expression%2C%20minimal%20design&width=120&height=120&seq=avatar-cm-02&orientation=squarish',
    name: '剑气近',
    time: '5小时前',
    content: '追了三年漫画，换了无数平台，最后还是稳定在尾巴漫画。更新快、资源全、不用等加载，国产漫画区也越来越丰富了，《剑尊归来》真的吹爆！',
    likes: 953,
    work: '在看《剑尊归来》',
  },
  {
    id: 'cm3',
    avatar: 'https://readdy.ai/api/search-image?query=A%20gentle%20anime%20style%20character%20avatar%20with%20brown%20hair%20and%20round%20glasses%2C%20simple%20warm%20toned%20gradient%20background%2C%20soft%20illustration%20style%2C%20warm%20smile%2C%20clean%20minimal%20design&width=120&height=120&seq=avatar-cm-03&orientation=squarish',
    name: '墨染青衣',
    time: '昨天',
    content: '作为老漫画迷，尾巴漫画的分类和索引功能做得真的用心，找冷门漫画也很方便。最近沉迷悬疑推理类漫画，专区里的推荐都很对我胃口，良心平台。',
    likes: 2104,
    work: '在看《完美基因》',
  },
];

export const cards = [
  {
    id: 'cd1',
    title: '我独自升级',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20illustration%20of%20a%20powerful%20hunter%20with%20dark%20armor%20and%20glowing%20eyes%2C%20standing%20in%20a%20dungeon%20portal%2C%20dark%20fantasy%20style%2C%20dramatic%20lighting%2C%20warm%20orange%20accents%20against%20deep%20shadows%2C%20professional%20manga%20cover%20art%2C%20clean%20composition&width=600&height=800&seq=card-cover-01&orientation=portrait',
    tag: '韩漫',
    tagBg: 'bg-primary-100 text-primary-700',
    desc: '十年前「门」突然出现连接异世界，程肖宇从最弱猎人觉醒为最强暗影君主，热血升级之路震撼开启。',
    status: '连载中',
    score: '9.8',
  },
  {
    id: 'cd2',
    title: '剑尊归来',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20illustration%20of%20a%20swordsman%20in%20elegant%20white%20hanfu%20holding%20a%20glowing%20sword%2C%20traditional%20Chinese%20martial%20arts%20theme%2C%20ink%20wash%20style%20with%20vibrant%20accents%2C%20mountain%20mist%20background%2C%20warm%20golden%20and%20coral%20tones%2C%20refined%20cover%20art&width=600&height=800&seq=card-cover-02&orientation=portrait',
    tag: '国漫',
    tagBg: 'bg-accent-100 text-accent-700',
    desc: '华山剑尊遭暗算后转世重生，携前世记忆重登武道巅峰，一剑在手天下我有，武侠迷必追神作。',
    status: '连载中',
    score: '9.6',
  },
  {
    id: 'cd3',
    title: '咒术回战',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20illustration%20of%20a%20character%20casting%20a%20powerful%20curse%20technique%20with%20flowing%20dark%20energy%2C%20modern%20urban%20supernatural%20theme%2C%20edgy%20anime%20style%2C%20crimson%20and%20black%20color%20palette%20with%20warm%20highlights%2C%20dynamic%20pose%2C%20cover%20art%20quality&width=600&height=800&seq=card-cover-03&orientation=portrait',
    tag: '日漫',
    tagBg: 'bg-secondary-100 text-secondary-700',
    desc: '虎杖悠仁吞下宿傩手指后踏入咒术世界，与伙伴们共同对抗诅咒，热血黑暗系神作持续高能。',
    status: '连载中',
    score: '9.7',
  },
  {
    id: 'cd4',
    title: '全知读者视角',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20illustration%20of%20an%20office%20worker%20holding%20a%20glowing%20book%20in%20a%20post%20apocalyptic%20world%2C%20fantasy%20elements%20emerging%20from%20pages%2C%20Korean%20webtoon%20art%20style%2C%20warm%20cream%20and%20teal%20accents%2C%20dramatic%20cover%20composition&width=600&height=800&seq=card-cover-04&orientation=portrait',
    tag: '韩漫',
    tagBg: 'bg-primary-100 text-primary-700',
    desc: '唯一读完末日小说的人目睹世界变成书中的样子，凭借全知视角在崩坏世界中步步为营。',
    status: '连载中',
    score: '9.5',
  },
  {
    id: 'cd5',
    title: '镖人',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20illustration%20of%20a%20fierce%20warrior%20with%20a%20broad%20sword%20in%20ancient%20Chinese%20desert%20setting%2C%20rough%20ink%20brush%20art%20style%2C%20dusty%20sandstorm%20atmosphere%2C%20warm%20earth%20tones%20and%20red%20accents%2C%20powerful%20composition%2C%20historical%20martial%20arts%20theme&width=600&height=800&seq=card-cover-05&orientation=portrait',
    tag: '国漫',
    tagBg: 'bg-accent-100 text-accent-700',
    desc: '隋末乱世，刀马行走西域护送神秘人物，硬派画风与厚重剧情成就国漫里程碑级作品。',
    status: '连载中',
    score: '9.9',
  },
  {
    id: 'cd6',
    title: '电锯人',
    cover: 'https://readdy.ai/api/search-image?query=A%20manga%20cover%20illustration%20of%20a%20character%20with%20chainsaw%20arms%20in%20a%20dynamic%20fighting%20pose%2C%20gritty%20urban%20background%20with%20spatter%20effects%2C%20bold%20anime%20art%20style%2C%20warm%20orange%20and%20dark%20crimson%20palette%2C%20intense%20expression%2C%20striking%20cover%20composition&width=600&height=800&seq=card-cover-06&orientation=portrait',
    tag: '日漫',
    tagBg: 'bg-secondary-100 text-secondary-700',
    desc: '为了偿还亡父的巨额债务，少年淀治与恶魔啵奇塔契约成为恶魔猎人，疯狂世界观令人上瘾。',
    status: '连载中',
    score: '9.4',
  },
];

export const indexItems = [
  { id: 'ix1', title: '热血战斗漫画大全', count: '486部', icon: 'ri-sword-line', desc: '从经典到新番，燃到停不下来' },
  { id: 'ix2', title: '恋爱甜漫精选集', count: '352部', icon: 'ri-heart-line', desc: '甜到牙疼的心动故事都在这里' },
  { id: 'ix3', title: '悬疑推理漫画专区', count: '218部', icon: 'ri-search-eye-line', desc: '烧脑反转，猜到结局算你赢' },
  { id: 'ix4', title: '韩漫人气排行榜', count: '603部', icon: 'ri-fire-line', desc: '韩国网漫一网打尽' },
  { id: 'ix5', title: '国漫原创孵化基地', count: '427部', icon: 'ri-brush-line', desc: '支持国产原创漫画作者' },
  { id: 'ix6', title: '搞笑日常解压漫画', count: '291部', icon: 'ri-emotion-laugh-line', desc: '笑到肚子疼的快乐源泉' },
  { id: 'ix7', title: '奇幻异世界冒险', count: '374部', icon: 'ri-rocket-line', desc: '穿越异世界开启第二人生' },
  { id: 'ix8', title: '完结漫画典藏馆', count: '1125部', icon: 'ri-bookmark-line', desc: '一口气看到结局不用追更' },
];

export const rankingItems = [
  { id: 'r1', rank: 1, title: '我独自升级', score: '9.8', trend: 'up', category: '韩漫·战斗', change: '+2' },
  { id: 'r2', rank: 2, title: '剑尊归来', score: '9.6', trend: 'up', category: '国漫·武侠', change: '+5' },
  { id: 'r3', rank: 3, title: '咒术回战', score: '9.7', trend: 'same', category: '日漫·热血', change: '—' },
  { id: 'r4', rank: 4, title: '镖人', score: '9.9', trend: 'down', category: '国漫·历史', change: '-1' },
  { id: 'r5', rank: 5, title: '全知读者视角', score: '9.5', trend: 'up', category: '韩漫·奇幻', change: '+3' },
  { id: 'r6', rank: 6, title: '电锯人', score: '9.4', trend: 'up', category: '日漫·黑暗', change: '+8' },
  { id: 'r7', rank: 7, title: '间谍过家家', score: '9.3', trend: 'down', category: '日漫·喜剧', change: '-2' },
];

export const features = [
  {
    id: 'f1',
    icon: 'ri-smartphone-line',
    title: '下拉式阅读',
    desc: '专为移动端优化的竖屏下拉阅读体验，无需翻页，手指滑动即可丝滑浏览每一话漫画，追更不费力。',
  },
  {
    id: 'f2',
    icon: 'ri-refresh-line',
    title: '实时追更提醒',
    desc: '订阅喜欢的漫画后，作者更新第一时间推送通知，再也不用担心错过任何一话精彩内容。',
  },
  {
    id: 'f3',
    icon: 'ri-hd-line',
    title: '高清画质引擎',
    desc: '自主研发的图像增强算法，对每一页漫画进行画质优化处理，即使放大也不模糊，细节分毫毕现。',
  },
  {
    id: 'f4',
    icon: 'ri-shield-check-line',
    title: '正版内容保障',
    desc: '与多家海内外漫画版权方深度合作，所有内容均为正版授权，为读者提供安全可靠的阅读环境。',
  },
];

export const mediaItems = [
  {
    id: 'm1',
    title: '《我独自升级》动画PV首曝',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20dramatic%20anime%20trailer%20thumbnail%20with%20a%20powerful%20character%20in%20action%20pose%2C%20dark%20dungeon%20background%20with%20glowing%20portal%2C%20cinematic%20lighting%2C%20warm%20orange%20energy%20effects%2C%20professional%20anime%20promotional%20art%2C%20play%20button%20friendly%20composition%2C%204K%20quality&width=640&height=360&seq=media-thumb-01&orientation=landscape',
    duration: '1:58',
    views: '128.6万',
    date: '3天前',
  },
  {
    id: 'm2',
    title: '《剑尊归来》作者专访幕后故事',
    thumbnail: 'https://readdy.ai/api/search-image?query=An%20interview%20style%20thumbnail%20with%20a%20manga%20artist%20workspace%2C%20drawing%20tablet%20and%20sketches%20visible%2C%20warm%20studio%20lighting%2C%20traditional%20Chinese%20elements%20in%20background%2C%20cozy%20creative%20atmosphere%2C%20soft%20cream%20and%20wood%20tones%2C%20documentary%20style%20composition&width=640&height=360&seq=media-thumb-02&orientation=landscape',
    duration: '8:23',
    views: '56.2万',
    date: '1周前',
  },
  {
    id: 'm3',
    title: '2026夏季新番导视·漫画篇',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20summer%20anime%20season%20guide%20thumbnail%20with%20multiple%20colorful%20character%20silhouettes%20arranged%20in%20a%20collage%2C%20bright%20sunny%20background%2C%20vibrant%20warm%20color%20palette%2C%20playful%20summer%20vibes%2C%20clean%20promotional%20design%2C%20text%20friendly%20lower%20area&width=640&height=360&seq=media-thumb-03&orientation=landscape',
    duration: '5:41',
    views: '89.3万',
    date: '2天前',
  },
  {
    id: 'm4',
    title: '尾巴漫画原创大赛获奖作品赏析',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20creative%20award%20ceremony%20style%20thumbnail%20with%20trophy%20and%20colorful%20manga%20panels%20framed%20on%20a%20gallery%20wall%2C%20warm%20spotlight%20illumination%2C%20elegant%20presentation%2C%20celebration%20atmosphere%2C%20gold%20and%20cream%20color%20scheme%2C%20prestigious%20composition&width=640&height=360&seq=media-thumb-04&orientation=landscape',
    duration: '12:05',
    views: '34.7万',
    date: '5天前',
  },
  {
    id: 'm5',
    title: '日漫大师富坚义博创作纪录片',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20documentary%20style%20thumbnail%20showing%20a%20manga%20master%20working%20at%20a%20traditional%20drawing%20desk%20with%20ink%20brushes%2C%20dim%20warm%20lamp%20light%2C%20stacks%20of%20manuscript%20papers%2C%20nostalgic%20atmosphere%2C%20Japanese%20studio%20setting%2C%20artistic%20composition%2C%20warm%20amber%20tones&width=640&height=360&seq=media-thumb-05&orientation=landscape',
    duration: '22:18',
    views: '201.5万',
    date: '1个月前',
  },
];

export const faqItems = [
  {
    id: 'faq1',
    question: '尾巴漫画所有内容都是免费的吗？',
    answer: '是的，尾巴漫画平台上的所有漫画内容均为完全免费阅读。我们通过广告和会员增值服务维持运营，基础阅读功能不收取任何费用，让每一位漫画爱好者都能无门槛享受阅读乐趣。',
  },
  {
    id: 'faq2',
    question: '漫画更新频率是怎样的？',
    answer: '不同漫画的更新频率有所差异。热门连载漫画通常保持周更节奏，部分高人气作品甚至达到每周双更。您可以在每部漫画的详情页查看具体更新计划，也可以订阅更新提醒，第一时间收到通知。',
  },
  {
    id: 'faq3',
    question: '支持离线下载阅读吗？',
    answer: '尾巴漫画APP客户端支持离线下载功能，您可以在WiFi环境下将喜欢的漫画章节下载到本地，通勤、旅行等无网络场景也能畅快阅读，下载内容长期有效。',
  },
  {
    id: 'faq4',
    question: '如何投稿自己的原创漫画作品？',
    answer: '我们非常欢迎原创漫画作者入驻！您可以通过「联系我们」模块提交投稿申请，我们的编辑团队会在3个工作日内进行审核评估，通过后即可在尾巴漫画平台发布您的作品，享受流量扶持和收益分成。',
  },
];

export const updates = [
  { id: 'u1', date: '2026-07-28', title: '《我独自升级》第198话更新上线', tag: '更新' },
  { id: 'u2', date: '2026-07-27', title: '尾巴漫画APP 4.2.0版本发布，新增夜间模式', tag: '升级' },
  { id: 'u3', date: '2026-07-26', title: '《剑尊归来》第87话——华山论剑篇高潮', tag: '更新' },
  { id: 'u4', date: '2026-07-25', title: '暑期阅读季活动开启，签到领漫画币', tag: '活动' },
  { id: 'u5', date: '2026-07-24', title: '《咒术回战》第261话——最终决战序幕', tag: '更新' },
  { id: 'u6', date: '2026-07-23', title: '新作《末世列车》独家上线尾巴漫画', tag: '上新' },
  { id: 'u7', date: '2026-07-22', title: '平台注册用户突破8000万里程碑', tag: '里程碑' },
  { id: 'u8', date: '2026-07-21', title: '《全知读者视角》第215话更新', tag: '更新' },
  { id: 'u9', date: '2026-07-20', title: '尾巴漫画×集英社达成战略内容合作', tag: '合作' },
];